import { motion, type TargetAndTransition } from "framer-motion";
import { LucideIcon } from "lucide-react";

export type AliveAnimation = "pulse" | "tilt" | "spin" | "glow" | "bounce";

interface AliveIconProps {
  icon: LucideIcon;
  animation?: AliveAnimation;
  className?: string;
}

const animations: Record<AliveAnimation, TargetAndTransition> = {
  pulse: { scale: [1, 1.15, 1], transition: { duration: 0.5 } },
  tilt: { rotate: -8, y: -2, transition: { duration: 0.3 } },
  spin: { rotate: 15, transition: { duration: 0.3 } },
  glow: { opacity: [0.7, 1], filter: "drop-shadow(0 0 6px hsl(243 75% 59% / 0.5))", transition: { duration: 0.4 } },
  bounce: { y: -3, transition: { type: "spring", stiffness: 400, damping: 10 } },
};

export function AliveIcon({ icon: Icon, animation = "pulse", className }: AliveIconProps) {
  return (
    <motion.div
      whileHover={animations[animation]}
      className="inline-flex"
    >
      <Icon className={className} />
    </motion.div>
  );
}
